import { render, staticRenderFns } from "./KanbanCard.vue?vue&type=template&id=a98e6dc8&"
import script from "./KanbanCard.vue?vue&type=script&lang=js&"
export * from "./KanbanCard.vue?vue&type=script&lang=js&"
import style0 from "./KanbanCard.vue?vue&type=style&index=0&id=a98e6dc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports